const getResponse = (node: any, language: string) => {
  const response =
    language !== "english" ? `response_${language.toLowerCase()}` : "response";
  return node?.[response] ? node?.[response] : node?.response;
};

export default getResponse;